"use strict";

exports.__esModule = true;
exports.getMargin = void 0;

const getMargin = num => {
  return `calc(${num * 15.25}pt + 1px * ${num - 1})`;
};

exports.getMargin = getMargin;